import { createContext, useContext } from 'react';

export const EventContext = createContext({
  events: [],
  selectedEvent: null,
  setSelectedEvent: () => {},
});

export function useEvent() {
  return useContext(EventContext);
}
